// extracted by mini-css-extract-plugin
export default {"text":"documents_text__qkKCo"};